import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../utils/api';
import { formatDateOnly } from '../utils/dateOnly';
import './Changelog.css';

const ChangelogPublic = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true);
        const res = await fetch(getApiUrl('changelog/public'));
        if (res.ok) {
          const data = await res.json();
          const list = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
          setItems(list);
        } else {
          setError('Falha ao carregar changelog público');
        }
      } catch (err) {
        console.error('Erro ao carregar changelog público:', err);
        setError('Erro ao carregar changelog público');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  const formatDate = formatDateOnly;

  const getTypeClass = (type) => {
    switch (type) {
      case 'feature': return 'chg-feature';
      case 'improvement': return 'chg-improvement';
      case 'bugfix': return 'chg-bugfix';
      default: return 'chg-default';
    }
  };

  return (
    <div className="changelog-page">
      <header className="changelog-header">
        <h1>📰 Changelog Público</h1>
        <button className="back-btn" onClick={() => navigate('/login')}>Login</button>
      </header>

      <main className="changelog-content">
        {loading && <div className="loading">Carregando...</div>}
        {error && <div className="error">{error}</div>}
        {!loading && !error && (
          <div className="changelog-list">
            {items.map((item) => (
              <div key={item.id} className={`changelog-item ${getTypeClass(item.type)}`}>
                <div className="item-icon">{item.icon || '📝'}</div>
                <div className="item-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <span className="item-date">{formatDate(item.date)}</span>
                </div>
              </div>
            ))}
            {items.length === 0 && (
              <div className="empty">Nenhuma atualização disponível no momento.</div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default ChangelogPublic;